function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.33 62.57 352.33 120.07 360.4 120.07 360.4 134.01 374.35 120.07 450.89 120.07 450.89 62.57 352.33 62.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.24,91.32a4.67,4.67,0,1,0,4.67-4.67A4.67,4.67,0,0,0,420.24,91.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.94,91.32a4.67,4.67,0,1,0,4.67-4.67A4.67,4.67,0,0,0,396.94,91.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.64,91.32a4.67,4.67,0,1,0,4.66-4.67A4.67,4.67,0,0,0,373.64,91.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.99 244.73 186.99 325.17 175.7 325.17 175.7 344.68 156.19 325.17 49.11 325.17 49.11 244.73 186.99 244.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,244.73c.07,22.87.58,57.84.6,80.44v.59H187l-11.29.05.65-.65.09,19.51v1.79l-1.27-1.26-19.59-19.44c-23.56.79-81.36.11-107.46.38v-1l.13-80.44v-.86h.85c34.38.16,103.52.54,137.88.85Zm0,0c-34.36.31-103.53.69-137.88.85l.85-.85.13,80.44-1-1c26.9,0,80.55.08,107.44.13l.24.25,19.44,19.58-1.27.53.09-19.51v-.66h.65l11.29.05-.6.6c.15-22.45.41-57.74.6-80.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,285a6.54,6.54,0,1,1-6.54-6.53A6.53,6.53,0,0,1,92,285Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,285a6.54,6.54,0,1,1-6.54-6.53A6.53,6.53,0,0,1,124.59,285Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.19,285a6.54,6.54,0,1,1-6.54-6.53A6.53,6.53,0,0,1,157.19,285Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.35 92.56 71.73 99.09 79.3 101.24 74.44 107.42 74.73 115.28 67.35 112.57 59.97 115.28 60.26 107.42 55.41 101.24 62.97 99.09 67.35 92.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.14 92.56 105.52 99.09 113.08 101.24 108.23 107.42 108.52 115.28 101.14 112.57 93.75 115.28 94.05 107.42 89.19 101.24 96.76 99.09 101.14 92.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.92 92.56 139.31 99.09 146.87 101.24 142.01 107.42 142.31 115.28 134.92 112.57 127.54 115.28 127.83 107.42 122.98 101.24 130.54 99.09 134.92 92.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.71 92.56 173.09 99.09 180.66 101.24 175.8 107.42 176.09 115.28 168.71 112.57 161.33 115.28 161.62 107.42 156.76 101.24 164.33 99.09 168.71 92.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41,116l-7.91-2.9-7.91,2.9.31-8.42L189.7,101l8.1-2.3,4.7-7,4.69,7,8.11,2.3-5.2,6.63Zm-7.91-4,6.85,2.51-.27-7.29,4.51-5.75-7-2-4.07-6.07-4.07,6.07-7,2,4.51,5.75-.27,7.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.5 112.57 202.5 92.56 198.12 99.09 190.55 101.24 195.41 107.42 195.11 115.28 202.5 112.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjP0--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.37,245.18c-2-1.23-3.67-3-6.29-2.75-1,.11-.79-.73-.8-1.27l-.12-29.56c0-.71,0-1.3.82-1.7,7.51-3.82,10.75-11.3,15.34-17.69a29.43,29.43,0,0,0,5.38-22.37c-.32-2.22.71-3.21,2.71-3.67,2.4-.56,4.8.1,5.63,1.75a39.85,39.85,0,0,1,4.34,12.89c.44,3.74-.88,7.38-1.34,11.08-.33,2.7-1,5.38-1.46,8.12.66.48,1.43.23,2.14.23q12.48,0,25-.07c3.5,0,5.23,1,5.72,3.32a6.65,6.65,0,0,1-3.6,7.22c-.62.32-1.75,0-1.82,1s1.09.89,1.66,1.29c3,2.06,2.48,6.32-1,8.8-.84.59-2.46.32-2.5,1.55,0,1,1.51,1,2.2,1.65,2.44,2.4,1.24,6.89-2.39,8.72a11.6,11.6,0,0,0-1.46.56c-.41.28-.81.6,0,1.16,3.61,2.56,3.55,6.15-.07,8.78l-1.08.78a7.05,7.05,0,0,1-4.38,1q-19.57.11-39.16.14A4.64,4.64,0,0,1,379.37,245.18Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.2,227.92c0-6.25,0-12.52-.09-18.77,0-1.28.12-1.9,1.68-1.89,7.64.07,15.26,0,22.9-.07,1.5,0,1.73.5,1.73,1.83q0,18.89.13,37.78c0,1.61-.42,2.06-2,2-7.41-.06-14.81-.05-22.21.09-1.84,0-2.1-.61-2.09-2.22C342.3,240.45,342.22,234.19,342.2,227.92Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjp0--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.81,328.84c1.48.94,2.77,2.29,4.76,2.1.77-.07.6.56.6,1q0,11.23,0,22.44c0,.54,0,1-.63,1.29-5.71,2.88-8.19,8.54-11.68,13.39a22.32,22.32,0,0,0-4.15,17c.24,1.69-.54,2.44-2.06,2.78-1.83.42-3.64-.08-4.27-1.34a30,30,0,0,1-3.26-9.8c-.33-2.83.69-5.6,1-8.4.26-2.06.74-4.08,1.13-6.16-.5-.37-1.08-.18-1.62-.19H195.74c-2.67,0-4-.77-4.34-2.53a5.07,5.07,0,0,1,2.75-5.48c.47-.24,1.33,0,1.39-.76s-.83-.68-1.26-1c-2.29-1.56-1.86-4.8.78-6.67.64-.45,1.87-.24,1.9-1.17,0-.75-1.14-.74-1.66-1.26-1.85-1.83-.93-5.23,1.83-6.61a8.23,8.23,0,0,0,1.11-.43c.31-.21.62-.44,0-.88-2.73-2-2.67-4.67.08-6.66l.82-.59a5.35,5.35,0,0,1,3.33-.72q14.86,0,29.72,0A3.55,3.55,0,0,1,234.81,328.84Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,342c0,4.75,0,9.51,0,14.26,0,1-.09,1.44-1.27,1.42q-8.7-.1-17.39,0c-1.13,0-1.31-.38-1.3-1.39q0-14.34,0-28.68c0-1.22.33-1.57,1.55-1.54,5.62.06,11.24.07,16.86,0,1.4,0,1.59.47,1.57,1.7C262.93,332.53,263,337.28,263,342Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6,453c132.23-.62,280.57-.62,412.8,0-132.23.61-280.57.61-412.8,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.23 95.72 321.31 103.04 329.85 105.61 324.44 112.7 324.64 121.61 316.23 118.66 307.82 121.61 308.02 112.7 302.62 105.61 311.16 103.04 316.23 95.72",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.15 220.47 146.22 227.8 154.76 230.36 149.36 237.45 149.56 246.36 141.15 243.42 132.73 246.36 132.94 237.45 127.53 230.36 136.07 227.8 141.15 220.47",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.95 301.06 205.49 304.72 209.76 306 207.06 309.55 207.16 314 202.95 312.53 198.74 314 198.84 309.55 196.15 306 200.41 304.72 202.95 301.06",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.66 210.22 368.2 213.89 372.46 215.17 369.76 218.71 369.87 223.17 365.66 221.7 361.45 223.17 361.55 218.71 358.85 215.17 363.12 213.89 365.66 210.22",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.98 80.45 289.52 84.11 293.79 85.39 291.09 88.94 291.19 93.4 286.98 91.92 282.78 93.4 282.88 88.94 280.18 85.39 284.45 84.11 286.98 80.45",
    style: {
      fill: "#E8B923"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.86,452.53c2.45.88,74.84,2.31,77.57.65.31-.17,1.49-24.12,1.49-24.12-.08-.34,1.13-2.65,3-5.86,5.16-9,15.25-25.14,15.25-25.14l-43-13-17.65,35.35-4.5,9s-9.87,3.85-18.48,7.7l0,0c-5.3,2.36-9.92,4.53-11,5.33C212.77,444.63,210.42,451.66,212.86,452.53Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,452.53c2.45.88,74.84,2.31,77.57.65.31-.17,1.49-24.12,1.49-24.12-.08-.34,1.13-2.65,3-5.86l-45.36-2.78-4.5,9s-9.87,3.85-18.48,7.7l0,0c-5.3,2.36-9.92,4.53-11,5.33C212.77,444.63,210.42,451.66,212.86,452.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.56,452.8c2.52.89,75,2.13,77.8.43,1.06-.64,2.34-11.8,1.56-24.17l-46.73-.75s-27.07,12-29.93,14.16S210,451.91,212.56,452.8Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,453.23c-1,.62-11.32.85-24.12.85l24.54-25h0l1.13,0C292.7,441.43,291.42,452.59,290.36,453.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65,449.91c12.16-.09,61.19.7,73.22,1.53.09,0,.09.08,0,.08-12.05.35-61.08-.83-73.22-1.41C213.39,450.1,213.39,449.92,213.65,449.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,439.94a9.76,9.76,0,0,1,7.22,3.09,9.48,9.48,0,0,1,2.61,6.54c0,.07-.14.07-.15,0a11.3,11.3,0,0,0-9.68-9.47A.08.08,0,0,1,220,439.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,429.47c4.87,0,10.48,1.82,13.43,5.85.12.16-.11.32-.25.24a67.52,67.52,0,0,0-13.27-5.5A.3.3,0,0,1,241.35,429.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,430.86c4.87,0,10.48,1.83,13.43,5.86.12.16-.11.32-.25.24a67.52,67.52,0,0,0-13.27-5.5A.31.31,0,0,1,237.57,430.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,432.26c4.86,0,10.47,1.83,13.42,5.86.12.16-.11.32-.25.24a67.52,67.52,0,0,0-13.27-5.5A.31.31,0,0,1,233.8,432.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,433.66c4.86,0,10.47,1.83,13.42,5.86.12.16-.11.32-.25.24a67.52,67.52,0,0,0-13.27-5.5A.31.31,0,0,1,230,433.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,439.85c5.46.11,5.29,8.59-.17,8.48S278.5,439.74,284,439.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.59,423.53c2.56,3.43,6.53,5.63,9.95,8.09a.6.6,0,0,0,.88-.38.12.12,0,0,0,.15-.14,25.54,25.54,0,0,0-4.2-12.51c-1.48-2.14-4.55-4.19-7.05-2.19S235.09,421.53,236.59,423.53Zm-.16-4c.58-5.28,5.28-1.14,6.31.49a27.32,27.32,0,0,1,1.72,3.31c1.07,2.35,1.79,4.81,2.62,7.25-1.61-1.31-3.32-2.47-5-3.71C240.14,425.35,236.11,422.41,236.43,419.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,428.3c-.33-3.18-3.94-3.93-6.51-3.48a25.47,25.47,0,0,0-11.87,5.78.12.12,0,0,0,0,.2.6.6,0,0,0,.35.9c4.15.71,8.5,2,12.74,1.41C262.1,432.78,265.21,431.31,264.9,428.3Zm-11.5,3.2c-2.05-.31-4.08-.71-6.14-.94,2.32-1.12,4.58-2.33,7-3.22a29.46,29.46,0,0,1,3.57-1.1c1.88-.4,8.13,0,4.77,4.16C260.75,432.67,255.84,431.86,253.4,431.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.18,423,250,415.73s23.18-46.2,37.52-71.27c8-13.94,29.81-14.62,40.42,2.08,14.18,22.31,25.19,43.22,31.49,54.81l10.94.94L368,420.16l-36.35,8.14c-13.93,1.66-23.7-23.13-23.93-22.71C305.93,408.85,298.18,423,298.18,423Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.44,405.7c1.37-2.81,2.44-5.79,3.66-8.66s2.36-5.57,3.53-8.36c2.37-5.63,4.82-11.24,7.11-16.9,1.29-3.18,2.47-6.4,3.68-9.61,0-.07.14,0,.12,0-.93,3-1.9,6.06-2.92,9.07.27-.52.54-1,.82-1.55.78-1.38,1.58-2.75,2.38-4.12,0-.05.11,0,.08.05-.74,1.38-1.48,2.75-2.25,4.11-.38.67-.8,1.34-1.2,2a211.39,211.39,0,0,1-10,24.71c-1.54,3.15-3.33,6.16-4.87,9.3C307.53,405.89,307.39,405.8,307.44,405.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,414.47c2.32-3.59,7.86-14.45,9.84-18.2,4-7.6,7.69-15.35,11.16-23.2,2-4.43,3.79-8.91,5.61-13.41a0,0,0,1,1,.05,0,255.83,255.83,0,0,1-9.52,23.82c-3.53,7.79-14.94,28.79-17,31.06C297.17,414.64,297,414.56,297.1,414.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,365.66c4.15,7.42,8.4,14.79,12.57,22.2,2.11,3.74,4.22,7.49,6.3,11.24,1,1.77,1.94,3.56,3,5.31a9.92,9.92,0,0,0,3.81,3.95,29,29,0,0,0,6,2.11c2.35.69,4.68,1.43,7,2.07.1,0,.05.2-.05.17-2.11-.56-4.23-1-6.34-1.57a54.17,54.17,0,0,1-5.75-1.55,9.38,9.38,0,0,1-4.26-2.94,34.34,34.34,0,0,1-3-5q-6.25-11.44-12.39-22.93c-2.33-4.35-4.64-8.72-7-13.06C327,365.65,327,365.63,327,365.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.27,416.27c-2.89-.52-5.85-.78-8.76-1.15L281.75,414c-5.83-.77-25.66-3.92-27.16-4.42-.1,0-.06-.19,0-.19,1.42,0,14.41,1.69,17.32,2.11,5.83.86,11.62,1.9,17.42,2.87,1.66.28,3.31.6,5,.89s3.31.65,5,.87C299.4,416.13,299.37,416.29,299.27,416.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.06,463.43c.92-2.43,47.08-58.21,50.11-59.19.35-.13,19.26,14.61,19.26,14.61.76,1.11,38.19-5.12,38.19-5.12L373,458.49l-67.5-4.37s-9.36,5-17.9,9h0c-5.25,2.48-9.9,4.57-11.21,4.85C273,468.67,266.12,465.85,267.06,463.43Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.4,468c1.31-.28,6-2.36,11.21-4.85h0c8.53-4,17.89-9,17.89-9l15,1,25.19-37c-5.2.69-9.08,1.07-9.33.71,0,0-18.9-14.73-19.25-14.6-3,1-49.19,56.76-50.11,59.19S273,468.67,276.4,468Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.65,463.49c1-2.49,47.33-58.22,50.44-59.23,1.18-.39,10.47,5.92,19.34,14.59l-29.93,35.9s-26.73,12.7-30.26,13.44S265.69,466,266.65,463.49Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.55,464.55c8-9.15,39.4-46.83,46.62-56.48.05-.08,0-.12-.06-.05-8.13,8.9-39.23,46.82-46.71,56.4C269.24,464.62,269.38,464.74,269.55,464.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.23,466.27a9.8,9.8,0,0,0,2.37-7.49,9.45,9.45,0,0,0-3.26-6.23c0-.05-.14.05-.09.11a11.27,11.27,0,0,1,.86,13.51A.08.08,0,0,0,281.23,466.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.12,456.9c3.17-3.7,5.45-9.13,4.33-14-.05-.19-.32-.12-.35,0a67,67,0,0,1-4.49,13.65A.3.3,0,0,0,303.12,456.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6,458.85c3.16-3.7,5.44-9.13,4.32-14,0-.19-.31-.12-.35,0a67.07,67.07,0,0,1-4.49,13.64A.31.31,0,0,0,299.6,458.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.07,460.8c3.16-3.7,5.45-9.13,4.32-14,0-.19-.31-.12-.34,0a67.69,67.69,0,0,1-4.49,13.64A.3.3,0,0,0,296.07,460.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,462.75c3.17-3.7,5.45-9.13,4.33-14-.05-.19-.32-.12-.35,0A67.07,67.07,0,0,1,292,462.43.3.3,0,0,0,292.54,462.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,417.83c3.48-4.21-3.05-9.62-6.54-5.41S319.58,422,323.06,417.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.74,469.24c3.15-.59,3.59-4.25,2.94-6.77a25.52,25.52,0,0,0-6.74-11.35.14.14,0,0,0-.21,0,.6.6,0,0,0-.86.43c-.37,4.19-1.29,8.63-.36,12.81C305.05,466.82,306.77,469.79,309.74,469.24ZM305.61,458c.13-2.07.37-4.12.42-6.19a75.15,75.15,0,0,1,3.79,6.72,27.16,27.16,0,0,1,1.39,3.46c.56,1.84.63,8.11-3.75,5.1C305.05,465.47,305.45,460.5,305.61,458Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.28,440.67c-3.21,2.84-5.08,7-7.24,10.58a.59.59,0,0,0,.45.85c0,.08.05.16.15.14A25.44,25.44,0,0,0,317.76,447c2-1.65,3.81-4.88,1.61-7.2S314.15,439,312.28,440.67Zm4-.49c5.31.14,1.56,5.17,0,6.33a26.61,26.61,0,0,1-3.16,2,76.22,76.22,0,0,1-7,3.2c1.17-1.71,2.18-3.5,3.29-5.25C310.76,444.36,313.36,440.11,316.29,440.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.86,399.81s47.89-5.16,66.84-.05c26.43,7.11,29.45,38.86,9.1,50.94C413,466,323.57,457.48,323.57,457.48l25-42.09s37.47-7,71.06-4.27l-67.77,8.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.81,418.22a1.41,1.41,0,0,0,.06-.22,1.05,1.05,0,0,1,.05-.19l.12-.43a9.07,9.07,0,0,1,.32-.87c.12-.29.24-.56.38-.84a5.62,5.62,0,0,1,.48-.78l.07,0a.05.05,0,0,1,0,0l.06,0,.07,0c4.11-.66,32-3.82,36.17-4.16s8.36-.59,12.55-.79a225.26,225.26,0,0,1,25.06.09c.78,0,1.56.12,2.34.18.17,0,.35-.07.52-.11.41-.09.81-.18,1.22-.25.76-.13,1.52-.22,2.28-.31,1.59-.2,3.19-.31,4.77-.57.1,0,.13.15,0,.17-1.6.31-3.17.75-4.77,1.06l-1.38.26c3.05.31,6.1.7,9.14,1.14.09,0,.09.18,0,.17-4.14-.45-8.33-.67-12.49-.77s-8.27-.18-12.41-.1c-8.37.16-16.75.62-25.1,1.22-4.69.33-33.15,3.65-37.85,3.66l-.06,0a2.13,2.13,0,0,1-.14.35c-.14.28-.28.55-.43.82s-.29.51-.46.75l-.24.37-.13.18a1.27,1.27,0,0,0-.13.19C346.9,418.41,346.75,418.33,346.81,418.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,454.85c1.48-2.42,2.76-5,4.12-7.52s2.73-5,4.1-7.52c2.74-5,12.51-21.81,13.45-23,.06-.07.17,0,.14.11-.48,1.31-6.61,12.45-8,14.93-2.82,5-5.76,9.82-8.66,14.71-.83,1.4-1.68,2.78-2.52,4.17s-1.73,2.75-2.51,4.18C336.47,455,336.35,454.94,336.4,454.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59,421.45c2.49-.54,5-.85,7.54-1.26s5-.82,7.55-1.22q7.54-1.22,15.12-2.28c10.06-1.41,20.15-2.51,30.28-3.14,5.71-.35,11.43-.5,17.15-.71.12,0,.11.2,0,.21a285.9,285.9,0,0,0-30.5,2.28q-15,1.71-30,3.85l-8.47,1.22c-2.86.42-5.73,1-8.61,1.24A.1.1,0,0,1,359.59,421.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,332c1.82,4.66,4.42,8.9,5.88,13.73a31.4,31.4,0,0,1,1.22,13.75c-2.59,16.9-24.6,27-40.06,21.8-7.39-2.52-13.83-8.52-15.79-16.21-2.4-9.43,2.63-18.49,5.69-27.1a44.11,44.11,0,0,0,2.48-15c0-4.47-.27-9,.63-13.44.65-3.15,2.8-12.31,14.4-16,8.33-2.62,16.77,1.93,20.65,9.84C381.34,312.59,378.12,322.76,381.73,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,333.38c-3.6,7.71-8.33,15.58-9.72,24.09-1.14,7.06.76,14.69,6.9,18.88,0,0,.11,0,.06-.08-6.45-5-7.25-13.63-5.44-21.06,1.85-7.61,6.31-14.23,8.56-21.68A.2.2,0,0,0,342,333.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.41,332.93C337.68,343,329.36,351,328.83,361.77c0,.12.19.16.2,0,.7-10.75,10-18.38,11.58-28.84C340.63,332.83,340.44,332.81,340.41,332.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.31,331.83A35.06,35.06,0,0,1,379.15,320a.2.2,0,0,0-.39,0c-1,14.84,16,26,11.51,41.33,0,.1.13.18.16.07,2.18-6.34.49-12.67-2.35-18.51C386.26,339.11,384.06,335.59,382.31,331.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,317.74c0-.28-.45-.2-.43.07a33.23,33.23,0,0,0,5.22,15.61c1.48,2.31,3.29,4.38,4.72,6.72,1.57,2.57,2.77,5.33,4.09,8a.06.06,0,0,0,.11-.05c-1.71-5.11-4.4-9.18-7.47-13.53A36.62,36.62,0,0,1,378.87,317.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,345.09c-22.63,15.22-41,29.76-42.93,39.91-2.72,14.05,5.79,18.4,9.69,18.62,10.61.62,34.86-35.26,42.36-51.36C362.41,336.62,351,341.74,346,345.09Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.12,352.26c-7.51,16.1-31.75,52-42.36,51.36-2.71-.15-7.63-2.29-9.49-8.28l53.92-52.44C357.87,344.39,357.45,347.27,355.12,352.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.26,399.75s-27,3.54-40.09,3.4c-11.74-.12-23.26-5.83-23.26-5.83l5.33-19.58s-5.31-6.77-1.2-14.11c2.93-5.22,12.11-16.4,17-21.63,11-11.81,20.24-5.11,23-1.36C389.32,355,398.26,399.75,398.26,399.75Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.66,376.2a44.36,44.36,0,0,0-7.45.39c-1.23.19-2.44.44-3.66.72-.61.14-1.22.25-1.83.37a7.29,7.29,0,0,1-1.92.15.05.05,0,0,0,0,.1,12.09,12.09,0,0,0,1.8.2,11.63,11.63,0,0,0,1.77-.14c1.25-.18,2.49-.42,3.74-.61,2.52-.38,5-.77,7.56-.95C356.78,376.42,356.78,376.2,356.66,376.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.38,379.46a48.91,48.91,0,0,0-6-1.13c-1-.12-2-.18-3.05-.2h-1.47c-.54,0-1.08.1-1.62.1a.05.05,0,0,0,0,.1c.5,0,1,.13,1.51.18l1.52.16,3,.32c2,.19,4.05.4,6.08.67C362.47,379.67,362.48,379.49,362.38,379.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,344.28c18.35,15.91,31.44,38.13,30.88,52.61-.56,14.3-5.47,12.67-6.88,12.51-8.61-1-27-41.76-32.41-58.27S376.43,340.35,381,344.28Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,397.68c-.91-1.85-1.85-3.68-2.74-5.55l-2.71-5.55c-1.78-3.71-3.6-7.4-5.33-11.14S379.72,368,378,364.25c-.86-1.88-1.7-3.76-2.5-5.65s-1.6-3.79-2.38-5.71a113.84,113.84,0,0,0,4.17,11.66c1.57,3.82,3.29,7.57,5,11.32s3.61,7.41,5.55,11.06S391.82,394.19,394,397.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,357.78a18.75,18.75,0,0,0-1.09-1.92c-.2-.3-.39-.61-.6-.91s-.41-.61-.66-.9a5.56,5.56,0,0,0,.84,2.08A6.08,6.08,0,0,0,374.93,357.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.29,350.39s12.35-9.86,18.81-9.63l5.47,4.88s1.8.6,2.35-.54c1.39-2.82,1.68-9.64-4.18-14.08-5.37-4.07-16.4-3.26-23.74-1.34-7.05,1.84-10.95,6-8.79,10.58S358.29,350.39,358.29,350.39Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.59,348.23s-5.72-5.92-6.54-9.35,6-6.68,10.46-7.95c6.85-2,11.51-1.52,15.34,2.14S357.59,348.23,357.59,348.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.55,338.06c-.11,1.2-5.25,7.26-10.59,7.74-1.74.15-2.36-7.08-2.36-7.08l-.25-.68-3.52-9.47,10.47-8.93,1.53-1.2s.79,2.66,1.74,6c.05.15.09.31.14.47s.12.36.16.54c.15.49.3,1,.44,1.5s.21.76.31,1.17l.32,1.21A65.36,65.36,0,0,1,367.55,338.06Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.57,324.41A20.21,20.21,0,0,1,354.35,338l-3.52-9.47,10.47-8.93,1.53-1.2S363.62,321.1,364.57,324.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,308.19c-6.9,16.34,2.11,22.32,5.63,23.8,3.2,1.35,14.26,5.53,22.82-10s3.14-23.91-4-27.38S347,291.86,340,308.19Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,307.2a12.1,12.1,0,0,0,1.2.23,2,2,0,0,0,1.28,0,.63.63,0,0,0,.29-.71,1.57,1.57,0,0,0-1.29-.93,2.27,2.27,0,0,0-1.64.2A.67.67,0,0,0,344,307.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,311.11a10,10,0,0,1-1-.69c-.39-.27-.72-.44-.9-.9a.65.65,0,0,1,.29-.71,1.56,1.56,0,0,1,1.57.25,2.28,2.28,0,0,1,1,1.3A.67.67,0,0,1,355.56,311.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.84,313.27s.07.09.05.14c-.52,1.09-.94,2.42-.1,3.23,0,0,0,.08,0,.06C350.61,316,351.18,314.22,351.84,313.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.34,312.55c1.84.65.41,4.27-1.29,3.68S351.8,312,353.34,312.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,313c.23.33.4.82.77,1s.9,0,1.34-.28c0,0,.06,0,0,.07-.26.7-.81,1.31-1.59,1.12a1.46,1.46,0,0,1-.87-1.75C353.69,313,353.88,312.89,354,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41,310.48c0-.05-.11,0-.13.07-.4,1.14-1,2.38-2.21,2.36,0,0-.05.06,0,.07C344.37,313.28,345.21,311.63,345.41,310.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,308.92c-1.76-.84-3.3,2.74-1.67,3.52S346.33,309.62,344.85,308.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,308.83c-.37.07-.8.29-1.15.17s-.52-.65-.61-1.13c0-.05-.05,0-.07,0-.32.68-.4,1.49.2,1.9s1.24,0,1.7-.63C344.17,309,344.15,308.8,344,308.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.27,322.31c-.35.2-.72.51-1.16.44a3.27,3.27,0,0,1-1.18-.62s-.08,0-.06.05a1.6,1.6,0,0,0,1.32,1,1.26,1.26,0,0,0,1.18-.8C348.41,322.33,348.33,322.28,348.27,322.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.78,316.63s-.78,1.64-1,2.45c0,.08.16.18.43.28h0a4,4,0,0,0,4.2-.25c.09-.06,0-.18-.08-.15a6.15,6.15,0,0,1-3.84-.11c0-.24,1.43-2.77,1.31-2.82a7.24,7.24,0,0,0-2-.17c1.53-3.47,3.61-6.67,5.08-10.15.05-.12-.12-.22-.19-.12a61.63,61.63,0,0,0-5.94,10.7C342.55,316.74,344.41,316.66,344.78,316.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35,319.08a5,5,0,0,0,1.28,2.13,2.28,2.28,0,0,0,1.22.55c1,.11,1.34-.71,1.45-1.48a5.84,5.84,0,0,0,0-1.24A6.31,6.31,0,0,1,344.35,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.63,321.21a2.28,2.28,0,0,0,1.22.55c1,.11,1.34-.71,1.45-1.48A2.29,2.29,0,0,0,345.63,321.21Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.09,321.37C364,321,365,313.78,365,313.78s-12.38-5.61-10.7-16.45a22.48,22.48,0,0,1-12.36,7s5.17-12.59,14.93-12.43c0,0,11-.91,15.59,9.82C377.12,312.7,369.2,321.65,367.09,321.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.46,296.54a12.1,12.1,0,0,0-.69,5,12.35,12.35,0,0,0,1.33,4.9,9.4,9.4,0,0,0,.64,1.11l.34.54c.13.18.26.34.4.5.27.33.53.67.82,1s.61.59.92.87l.47.43.52.37,1,.73c.73.43,1.47.81,2.22,1.19-.66-.52-1.36-1-2-1.49l-.94-.8-.46-.4c-.15-.15-.28-.3-.42-.45l-.84-.89c-.26-.31-.49-.65-.74-1l-.37-.48-.31-.52a11,11,0,0,1-.59-1.06,14,14,0,0,1-1.43-4.62,15.23,15.23,0,0,1-.13-2.44A15.77,15.77,0,0,1,354.46,296.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.08,320.14s5.38-4.07,7.35-2-3.28,8.82-6.42,9a3,3,0,0,1-3.33-2.78Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.88,320.05s0,.08,0,.08c-2.23.16-3.85,1.65-5.19,3.31a1.65,1.65,0,0,1,2.49.33c0,.05,0,.12-.08.09a1.83,1.83,0,0,0-2.13,0,8.23,8.23,0,0,0-1.43,1.27c-.15.14-.44-.06-.31-.24l0,0C365,322.31,368.1,319.43,370.88,320.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.59,348.23s10.38-13.65,20.36-15l-.85,7.49s-8.32.13-18.81,9.63Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.79,340.91a12.81,12.81,0,0,0-5.36.7c-6.85,1.61-13.84,7.23-13.84,7.23l-2,1.85-.22.2-.25-.13c-3.35-1.82-6.72-6.06-7.35-6.89a44.56,44.56,0,0,0,7.71,6.14l-.47.08,2-1.9c.7-.61,8.35-5.64,14.28-7.07.44-.12.91-.2,1.36-.29s.92-.13,1.38-.15A8.25,8.25,0,0,1,379.79,340.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.57,345.64a29.31,29.31,0,0,1-5.47-4.88A30.25,30.25,0,0,1,380,343,27.75,27.75,0,0,1,382.57,345.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,346.64a55.28,55.28,0,0,1,1.69,9.34c.22,2.2,0,10.18-2.48,10.08s1.12-5.51,1.49-9.73-1-7.19-1.33-9.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.06,346.53a50.08,50.08,0,0,0-2.32,8.36c-.39,2-.85,9.25,1.4,9.37s-.55-5.1-.53-9,1.5-6.46,2-8.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,364.56c.72-6.76,2.32-16.2,4.66-18.24s11.39-9.34,14-10.34,14.27-5.87,16.47-4.69c1.77.95-.14,5.58-5.68,7.95a81.49,81.49,0,0,0-8.74,4.61c-1.42.67-4.73,5.43-3.72,7.47.59,1.19,4.17,2.51,6.34,1.44s2.57-5.43,5-7.57,6.89-2,7.18-.84-1.15,1.8-3.28,5.94c-1.38,2.66-1.27,8.94-4.43,13.54a77.82,77.82,0,0,0-4.29,8.43Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,343.26a4.32,4.32,0,0,0,2.16-1.06,1.74,1.74,0,0,0,.47-.91,1.82,1.82,0,0,0,0-.57.88.88,0,0,0-.23-.53c-.05,0,0-.08,0,0s.15.17.21.26a1.57,1.57,0,0,1,.14.25,1.5,1.5,0,0,1,.11.55,1.79,1.79,0,0,1-.4,1.13,3,3,0,0,1-2.49,1A0,0,0,0,1,337.47,343.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,346.32c2-3.43,7.3-9.66,12.65-11.92,3.61-1.52,16.42,4.2,16.13,6.63s-2.44,2.49-5.64,2.22c-1.17-.1-7.38-2.1-8.39-.78-1.44,1.9-3.14,8.29-3.14,8.29Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,340.09c-1.64-2.52-5.11-3.79-8.55-4.76a0,0,0,1,0,0,.08c.88.25,6.51,2.62,8.54,4.73C339.91,340.16,339.94,340.12,339.93,340.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,346.32c2-3.43,7.3-9.66,12.65-11.92,3.61-1.52,13.84,6,13.55,8.43s-3.37,2.71-6.83,1.63c-1.12-.34-4.91-2.83-5.91-1.51-1.45,1.9-5,6.62-5,6.62Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,346.65c.32-.54.44-.73.77-1.26s.68-1.06,1.05-1.57a4.75,4.75,0,0,1,1.09-1.23,2.46,2.46,0,0,1,1.5-.35,8.6,8.6,0,0,1,3.31,1.34c1.15.6,3.51,1.57,5.29,1.33a3.53,3.53,0,0,0,1.39-.43,2.12,2.12,0,0,0,.82-.7c.73-1.34-.28-2.81-1.3-3.83a22.82,22.82,0,0,0-6.87-4.37c-.6-.27-1.21-.53-1.82-.78a5.28,5.28,0,0,0-2.18-.55c-1.24,0-3.23,1.36-3.85,1.76,0,0-.08-.05,0-.08.74-.5,2.58-2.1,4.58-2.07a6.41,6.41,0,0,1,2.11.63c.7.28,1.4.58,2.09.9a28.65,28.65,0,0,1,3.88,2.13,11.84,11.84,0,0,1,3.22,2.84,3.47,3.47,0,0,1,.33,3.56,3,3,0,0,1-2.21,1.27,5.51,5.51,0,0,1-1.57,0,25.31,25.31,0,0,1-3.46-.89c-1.1-.4-2.1-1.09-3.23-1.4a2.1,2.1,0,0,0-1.61.16,5.36,5.36,0,0,0-1.18,1.15,17.22,17.22,0,0,0-1.94,2.46C322,347,321.87,346.88,322,346.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,349.3c.73-1.63,1.84-8.25,3-10.31s6.78-9.23,9.5-9c3.41.27.07,6.52-1.63,9.11s-1.26,6.86-1.26,6.86Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.25,334.81c-.6.82-1.14,1.72-1.66,2.6a21.36,21.36,0,0,0-1.44,2.55,8.8,8.8,0,0,0-.57,2.83c0,.47,0,.94,0,1.42s.08,1,.09,1.56a0,0,0,1,0,.08,0,22.6,22.6,0,0,1,.28-2.83,12.17,12.17,0,0,1,.76-2.84c.74-1.81,1.85-3.44,2.6-5.24C323.4,334.79,323.3,334.75,323.25,334.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,346.66a9.76,9.76,0,0,0,1,4.76,18.08,18.08,0,0,0,1.16,2.17,18.61,18.61,0,0,0,1.48,2,18.92,18.92,0,0,1,2.61,3.89,19.57,19.57,0,0,1,1.45,4.52,12.63,12.63,0,0,0-.76-4.81,14.67,14.67,0,0,0-2.53-4.22,23.13,23.13,0,0,1-2.68-3.88A14.24,14.24,0,0,1,319.71,346.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,403c6.59-1.18,10.45-12.46,17.18-32.29,1.18-3.48-17.06-23.77-19.28-20.53-2.8,4.08-9.84,26.45-10.43,32.49C300.21,394.58,306.18,404.38,313.88,403Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.53,381.77l-22.27-19.85s-5.3,18.14-4.41,25.61,3.87,15.89,12.91,16C320.53,403.56,327.53,381.77,327.53,381.77Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24,396.44c.72-1.12,1.36-2.3,2-3.48s1.19-2.39,1.74-3.6,1.06-2.46,1.49-3.72a22.69,22.69,0,0,0,1.08-3.87c-.51,1.23-1.06,2.44-1.61,3.65l-1.64,3.63c-.53,1.22-1.08,2.43-1.58,3.67S321.69,395.18,321.24,396.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.08,385.59c-1.08-1.1-2.27-2.1-3.42-3.13s-2.31-2-3.48-3c-2.35-2-4.7-4-7.08-6-.65-.53-1.31-1.07-2-1.59s-1.49-1-2.19-1.6c-.05-.05-.12,0-.07.08.57.5,1.07,1.09,1.63,1.6s1.16,1.06,1.75,1.57c1.17,1,2.33,2,3.51,3,2.34,2,4.69,4,7.1,5.93,1.36,1.09,2.7,2.23,4.12,3.24A.08.08,0,0,0,323.08,385.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44,347l9,27.93a1,1,0,0,1-.83,1.57l-14.66,1a2.37,2.37,0,0,1-2.13-1.38l-9-27.92c-.36-.82,0-1.52.83-1.58l14.65-1A2.4,2.4,0,0,1,351.44,347Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,347.12l9,27.93a1,1,0,0,1-.83,1.57l-14.66,1a2.37,2.37,0,0,1-2.13-1.38l-9-27.93a1,1,0,0,1,.83-1.57l14.65-1A2.4,2.4,0,0,1,349.7,347.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76,348.68a1.25,1.25,0,1,0,1.14-1.35A1.25,1.25,0,0,0,345.76,348.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,409.24c-6.4.88-14.38-4.09-35.06-19.19-2.86-2.08,6.45-26.25,9.62-24.17,4,2.61,18.93,13.61,19.92,14.55C409.86,388.38,411.37,408.65,407,409.24Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,373.19s-5.89-8.27-10.33-11.65a35.81,35.81,0,0,0-15.91-6.44c-6.2-.91-21.81,1.17-22,5.77-.17,4.17,15.69,1.24,15.69,1.24s-16.66.32-15.94,5.37,18.93.6,18.93.6-17.11.72-15.54,5.81c1.18,3.85,17.9.75,17.9.75s-14.7.72-13.65,4.73c1.15,4.43,16.77,2.54,16.77,2.54,4.38,9.74,10.65,12.49,15.21,14C381.22,396.28,389,373.19,389,373.19Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,361.63c-2,0-3.94-.08-5.89.06s-3.91.35-5.84.67a33.46,33.46,0,0,0-7.4,2c4.35-1.35,11.34-2,13.29-2.11s3.9-.38,5.85-.52C362.24,361.7,362.23,361.63,362.18,361.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.82,368.67c-2.5.07-5,0-7.49.22s-4.83.56-7.3.91c-.19,0-.12.12.08.1,2.48-.25,4.79-.29,7.27-.51s5-.53,7.45-.66C362.86,368.73,362.86,368.67,362.82,368.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.45,374.62A56.21,56.21,0,0,0,353,375.83c-.19,0-.08.15.12.12,3.79-.47,6.76-.87,11.3-1.19C364.52,374.75,364.53,374.63,364.45,374.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,369.9l-8.15,29.7s21.86,12.87,26.69,9.46,1.67-20.55-3.79-27.09C401.45,379.25,389,369.9,389,369.9Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.71,370.89l.32-1-.08,0c2.06,1.69,4.13,3.36,6.18,5.06s4.09,3.4,6,5.2a30.47,30.47,0,0,1,2.77,2.8,23.18,23.18,0,0,1,2.2,3.25,25.22,25.22,0,0,1,2.64,7.46,21,21,0,0,0-2.14-7.72,19.17,19.17,0,0,0-2.17-3.42,31,31,0,0,0-2.8-2.92c-2-1.8-4.06-3.48-6.16-5.12s-4.28-3.19-6.5-4.67l-.07,0v.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.77,377.27c-.5,1.46-.88,3-1.29,4.45s-.81,3-1.19,4.47c-.76,3-1.5,6-2.2,9-.19.83-.38,1.65-.56,2.47s-.27,1.79-.47,2.67c0,.07.09.1.11,0,.2-.73.5-1.44.72-2.16s.42-1.52.62-2.28c.4-1.49.79-3,1.17-4.48.76-3,1.51-6,2.17-9,.37-1.71.8-3.41,1.07-5.13A.08.08,0,1,0,393.77,377.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.55,397a17.61,17.61,0,0,1-.4,2.73l-.15-.37a34.1,34.1,0,0,1,4.72,3.08,17.28,17.28,0,0,1-5.07-2.51l-.22-.15a19.46,19.46,0,0,1,1.12-2.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.44,356.63s-22.11,39.1-22.12,39.13c-3.56,7.88-6.53,14.86-7.73,18.61a.14.14,0,0,0,0,.06,6,6,0,0,0-.51,2.7s0,.05,0,.07c1.63,2.64,63.81,32.86,66.33,33.18s3.65-6.84,2.17-9.94-20.12-25.31-20.12-25.31l21.71-39.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42,450.16c-2.52-.33-63.71-30.32-65.34-33a.25.25,0,0,1,0-.07,6,6,0,0,1,.51-2.7.11.11,0,0,1,0-.06c1.2-3.75,4.18-10.73,7.72-18.62,0,0,3.73-6.83,5.21-9.2L103.07,407l-4.61,8.14s17.64,22,19.12,25.08S118,450.49,115.42,450.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.55,449.31c-2.54-.38-64.49-32.3-66.07-35-.62-1,3.5-10.32,8.81-21.41l.17-.35,40.2,20.15-.37.67s18.25,22.82,19.68,26S119.09,449.71,116.55,449.31Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.09,446.55c-10.31-5.64-52.43-27.4-63-32.18-.09,0-.12,0,0,.06,10.09,5.81,52.39,27.23,63,32.29C117.23,446.83,117.31,446.67,117.09,446.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.59,415.21c-3.72-2.89-9.07-4.85-13.72-3.54-.18.06-.1.31,0,.34a64.8,64.8,0,0,1,13.38,3.71A.3.3,0,0,0,102.59,415.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.63,418.52c-3.71-2.88-9.06-4.84-13.71-3.53-.18.05-.11.31,0,.33A65,65,0,0,1,104.35,419,.29.29,0,0,0,104.63,418.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68,421.84C103,419,97.61,417,93,418.31c-.18.05-.1.3.05.33a64.63,64.63,0,0,1,13.38,3.71A.3.3,0,0,0,106.68,421.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.11,404.75c-3.33-4.56-10.42.62-7.08,5.18S69.45,409.32,66.11,404.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,416.78l4.45,27.82a108.33,108.33,0,0,0,10.08,4.71c2.53.4,3.83-6.81,2.42-10C117.89,437,107.16,423.27,102,416.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.64,447.58c.89,1-1.27,4.6-2.22,4.48S48.07,416.85,47.06,416s1.53-4.75,3-4.27S118.64,447.58,118.64,447.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.43,382.9,108,406.69s56.24-80.16,57.36-101.21c1.56-29.09-23.28-121.42-23.28-121.42l-39.61-.27s16.11,95,14.8,111.16C116.57,303.42,63.43,382.9,63.43,382.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,397.48c-2.29-1.66-23.41-13.89-39.49-21.71a.09.09,0,0,0-.09.16c4.88,3.22,36.41,20.49,39.47,21.72C111.86,397.69,112,397.55,111.87,397.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76,274.66c-1.84-13.9-3.87-27.77-6.18-41.6s-4.76-27.76-7.66-41.54q-.54-2.52-1.1-5a.2.2,0,0,0-.4.08c2.44,13.67,5,27.32,7.19,41S119,255,120.84,268.78q.69,5.1,1.35,10.22a90,90,0,0,1,1,10.61,27.23,27.23,0,0,1-1.69,9.95,57,57,0,0,1-4.57,8.94c-7.16,12.12-39.26,65.1-40.09,66.64,0,.1.09.21.15.11,7.7-12,31.59-50.12,38.86-62.44,3.28-5.56,7-11.19,8.11-17.67C125.08,288.4,123.64,281.35,122.76,274.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.34,382.9s-.44,45.19-.44,45.22c.23,8.64.6,16.21,1.15,20.12a.13.13,0,0,0,0,.06,6.07,6.07,0,0,0,.71,2.65l.06.05c2.62,1.67,71.75,1.78,74.16,1s.3-7.75-2.38-9.89-29.14-14-29.14-14l0-45.16Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,418.84s-.09,9.25-.09,9.28c.23,8.64.6,16.21,1.15,20.12a.13.13,0,0,0,0,.06,12,12,0,0,0,.71,2.65l.06.05c2.62,1.67,71.75,1.78,74.16,1s.3-7.75-2.38-9.89-29.14-14-29.14-14v-9.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,451.89c-2.44.77-72.12-.45-74.74-2.19-1-.64-1.42-10.8-1.57-23.09v-.39l45,.29,0,.76s26.46,12.4,29.14,14.61S189.47,451.12,187,451.89Z",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.28,449.17c-11.74-.5-59.14-1.38-70.78-1-.09,0-.1.07,0,.07,11.62.75,59,1.25,70.78,1.1C186.53,449.36,186.53,449.18,186.28,449.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.41,427.47c-4.6-.94-10.27-.33-13.86,2.9-.14.13,0,.32.19.28a64.52,64.52,0,0,1,13.65-2.59A.3.3,0,0,0,159.41,427.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,429.54c-4.61-.94-10.28-.33-13.87,2.9-.14.12,0,.32.19.28a64.52,64.52,0,0,1,13.65-2.59A.3.3,0,0,0,162.72,429.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,431.61c-4.61-.94-10.28-.33-13.87,2.9-.13.12,0,.32.2.28A64.43,64.43,0,0,1,166,432.2.3.3,0,0,0,166,431.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.13,449.41c1.24.5.9,4.68,0,5s-76.87-1.35-78.16-1.66-.73-4.94.78-5.15S188.13,449.41,188.13,449.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,434.23c-5-2.62-9.08,5.16-4.07,7.78S127.09,436.85,122.08,434.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,184v0c-.26.82-14.5,39.83-15.84,40.45-1.52.7,31.45,56.07,33.4,81.8,1.24,16.45-1.2,109.56-1.2,109.56H109.73s2.31-83.71,3.41-110.23c.43-10.29-33.09-61.5-33.5-93.38-.13-10.05,7.09-28.42,7.09-28.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,304.87c0-.43-.34-.56-.37-.13-1.09,14.36-1.34,28.63-2,43s-.29,17.79-.93,32.13c-.36,8.11,0,16.25-.21,24.37a.1.1,0,0,0,.2,0C111.58,390,113.41,313,113.42,304.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.12,306.82a70.78,70.78,0,0,0-1-10.57,53.13,53.13,0,0,0-3-9.92c-2.67-6.71-5.81-13.26-8.82-19.82s-6.16-13.27-9.37-19.85q-2.72-5.53-5.46-11.06c-1.85-3.72-3.84-7.38-5.78-11.06a.13.13,0,0,0-.23.11c3.09,6.63,6.13,13.28,9.22,19.91s6.12,13.29,9.16,19.95,6,13.1,8.79,19.73a64.74,64.74,0,0,1,3.44,9.74,57.14,57.14,0,0,1,1.41,10.5c.46,8.23.69,16.49,1.5,24.7,0,.1.18.09.18,0C159.46,321.74,159.34,314.25,159.12,306.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.43,406.29c-2.8-.36-24.16-1.1-42-.34a.09.09,0,0,0,0,.18c5.83.52,38.72.74,42,.37C154.51,406.49,154.56,406.31,154.43,406.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.38,222.29a92.67,92.67,0,0,0-15.07,5.23.16.16,0,0,0,.11.31c5-1.59,10.2-3.07,15.16-4.93A.32.32,0,0,0,132.38,222.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,189.26c0-.17-.28-.24-.3-.06-.55,5.76-1.44,10.78-2.47,16.11-.48,2.47-3.91,16.06-8.13,14.61-.71-.25-1-1-1-2.1a17.5,17.5,0,0,1,1-4.17c.78-2.84,1.46-5.7,2-8.59a79.29,79.29,0,0,0,1.49-16.33.14.14,0,0,0-.28,0,149.86,149.86,0,0,1-3.62,22.39c-.91,3.54-3.27,8.75.42,9.69s7.17-7.84,7.89-10.27A83,83,0,0,0,137.24,189.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.42,220.3a23.71,23.71,0,0,0-1.27,2.76,6.48,6.48,0,0,0-.64,2.31c0,.15.2.19.29.09a8.38,8.38,0,0,0,1.24-2.18c.42-.85.86-1.69,1.25-2.56A.48.48,0,0,0,126.42,220.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35,319c.25-6.85,1-14-1.24-20.65a68.36,68.36,0,0,0-4.39-9.38q-2.5-4.83-4.92-9.71c-6.44-13-12.51-26.22-17.93-39.68-2.61-6.49-4.94-13.14-5.87-20.1a61.88,61.88,0,0,1,1.34-21.86c.41-1.78.84-3.56,1.33-5.32,0-.13-.16-.2-.2-.07a71.94,71.94,0,0,0-3.76,20.9,59.13,59.13,0,0,0,3.63,20c2.31,6.72,5.2,13.26,8,19.77q4.41,10.08,9.16,20c3.15,6.57,6.51,13,9.84,19.51a35.35,35.35,0,0,1,3.7,9.85,51.21,51.21,0,0,1,.4,10.79c-.57,15.15-1.88,65.6-2.07,80.72,0,1.92,0,3.84-.07,5.75,0,.17.26.2.27,0C116.58,384.47,117.81,334.14,118.35,319Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54,193.79c0-.11-.16-.09-.18,0-.57,4.17-.89,8.5-2.91,12.28-1.84,3.47-5.07,5.71-8.58,7.28a65.09,65.09,0,0,1-6.26,2.31c-.15.05-.11.28,0,.25,4-.83,8-1.76,11.51-4,3.7-2.39,5.61-6.23,6.22-10.52A36.54,36.54,0,0,0,107.54,193.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,127.73c8.19,15.64,33.92,38.24,42.12,40.22,10.12,2.43,32.58-14.51,41.29-24.49,3.6-4.13-11.41-22.13-17.87-21.29-3.56.47-21.77,18.76-24.78,17.5-7.25-3-17.33-9.22-31.72-17.55C137.21,117.59,130.91,118,136,127.73Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,128.2s4.08-7.27,6.58-10.07,15.64-9.82,17.32-7.07c2.16,3.56-4.63,9.1-8.31,11.38,0,0,5,8.22,1,13.26S193.78,128.2,193.78,128.2Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.65,146.14c2.78-1.59,14.87-10,17.71-13.07s10.37-12.57,8.23-15-4.57.18-4.57.18,2.54-4.5.16-6.74-6,1.93-6,1.93,2.28-4.82-.26-6.88-5.49,2.75-5.49,2.75,2.28-4.31-.52-5.13c-3.37-1-6.69,7.44-10.08,10.61-.77.72-16.66,13.51-16.66,13.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.67,108.91c-2.46,6.19-4.6,8.47-9.9,12.33-.1.08,0,.25.1.18,5.53-3.31,8.64-5.78,10.1-12.4C227.05,108.69,226.79,108.62,226.67,108.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.34,113c-3.11,6.2-5.41,8.7-10.66,13.15-.08.06,0,.2.1.14,5.52-3.94,8.56-6.48,10.85-13.09C232.74,112.87,232.49,112.68,232.34,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.74,118.48c-3.45,5.79-5.86,8.64-11.51,12.3a.13.13,0,0,0,.13.22c6.12-3.18,9.15-6.71,11.55-12.39C238.07,118.22,238,118.12,237.74,118.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,112.23c-.36,4.67-5.39,7.35-8.79,9.83a.39.39,0,0,0,0,.64c1.87,3.58,3.47,9.18,1.49,13a.1.1,0,0,0,.17.1c2.67-3.77,1.55-9.4-.75-13.2,3.53-2.48,8.45-5.4,7.95-10.33A0,0,0,0,0,218,112.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.21,131.3,154,154.91s-17.79-22-21.19-29.95C129,116,134.38,116,143,119.38S164.21,131.3,164.21,131.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.75,129.43a1.83,1.83,0,0,1-.85-.24,1.61,1.61,0,0,1-.79-1.41,1.91,1.91,0,0,0-1.19-1.73,2.08,2.08,0,0,0-1-.1c-.32,0-.65.07-1,.13l1,.12a2,2,0,0,1,.87.22,1.59,1.59,0,0,1,.84,1.37,1.9,1.9,0,0,0,1.13,1.76,1.85,1.85,0,0,0,1,.14c.33-.05.66-.07,1-.13C158.41,129.5,158.08,129.47,157.75,129.43Zm-25-5.44c0-.33-.07-.65-.13-1-.06.33-.08.65-.12,1a.5.5,0,0,1,0,.12l.25.62A2.06,2.06,0,0,0,132.72,124Zm16.19,14.3a1.78,1.78,0,0,1-.78.43,1.61,1.61,0,0,1-1.55-.43,1.91,1.91,0,0,0-2.06-.39,2.07,2.07,0,0,0-.81.67c-.2.26-.41.5-.6.78.27-.19.52-.4.78-.6a2,2,0,0,1,.77-.47,1.61,1.61,0,0,1,1.56.38,1.88,1.88,0,0,0,2.87-.19c.2-.26.41-.51.6-.78C149.42,137.88,149.17,138.09,148.91,138.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,130.28c-1.71,2.83-5.64,12-6.3,13.56-.35.8-1.61,4-2,4.84,0,.1.12.15.16,0,.68-1.51,1.52-3,2.21-4.47s5-10.74,6-13.92A.06.06,0,0,0,159.58,130.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,125c3.4,8,21.19,30,21.19,30l5.26-12.17-24.72-25.43C131.52,117.47,130.52,119.63,132.8,125Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,194.22l68.13,13.2c-.26,1.34,2.92-47-2.06-80.55-1.47-9.92-12.61-14.61-23-5.84C101.35,139.49,80.05,195.09,80.21,194.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,163.15l-.32.64.2-.22c.19-.26.41-.51.59-.78C94.64,162.9,94.48,163,94.33,163.15Zm53.36,31a1.9,1.9,0,0,0-2.06-.38,2,2,0,0,0-.81.66c-.2.26-.41.51-.6.78.27-.19.52-.4.78-.6a2,2,0,0,1,.77-.46,1.59,1.59,0,0,1,1.56.38,2,2,0,0,0,1.45.58c0-.16,0-.32,0-.48A1.61,1.61,0,0,1,147.69,194.12Zm-39.95,3.62a1.91,1.91,0,0,1-.78.44,1.62,1.62,0,0,1-1.55-.44,1.92,1.92,0,0,0-2.07-.38,2,2,0,0,0-.8.66l-.36.46.14,0h0l.39-.3a2,2,0,0,1,.76-.46,1.6,1.6,0,0,1,1.57.38,1.88,1.88,0,0,0,2.87-.2c.2-.26.41-.5.6-.78C108.25,197.33,108,197.54,107.74,197.74Zm17.86-35.18a1.81,1.81,0,0,1-.77.43,1.6,1.6,0,0,1-1.56-.43,1.88,1.88,0,0,0-2.06-.38,2,2,0,0,0-.81.66c-.2.26-.41.51-.6.78.27-.19.52-.4.78-.6a1.82,1.82,0,0,1,.77-.46,1.58,1.58,0,0,1,1.56.37,1.91,1.91,0,0,0,2,.45,1.85,1.85,0,0,0,.83-.64c.2-.26.41-.51.6-.78C126.11,162.15,125.86,162.36,125.6,162.56Zm22.07-23.8a1.56,1.56,0,0,1-1.09-.47,1.91,1.91,0,0,0-2.06-.39,2.07,2.07,0,0,0-.81.67c-.2.26-.41.5-.6.78.27-.19.52-.4.78-.6a2,2,0,0,1,.77-.47,1.61,1.61,0,0,1,1.56.38,1.94,1.94,0,0,0,1.49.57A3.73,3.73,0,0,0,147.67,138.76Zm1.15,19a1.93,1.93,0,0,0-1.46,1.11,2,2,0,0,0-.13,1c0,.32.07.65.13,1,.06-.32.08-.65.12-1a2,2,0,0,1,.25-.86,1.61,1.61,0,0,1,1.11-.77C148.83,158.07,148.82,157.9,148.82,157.72Zm-40-7.55c0-.33-.07-.66-.13-1-.06.32-.08.65-.13,1a2,2,0,0,1-.21.86,1.6,1.6,0,0,1-1.37.84,1.93,1.93,0,0,0-1.77,1.13,2,2,0,0,0-.13,1c0,.33.07.65.13,1,.06-.33.08-.65.13-1a1.87,1.87,0,0,1,.24-.86,1.63,1.63,0,0,1,1.41-.79,1.9,1.9,0,0,0,1.73-1.19A2,2,0,0,0,108.84,150.17ZM93.38,183.32c0-.32-.07-.65-.13-1-.06.33-.08.66-.12,1a2,2,0,0,1-.22.87,1.59,1.59,0,0,1-1.37.84,1.9,1.9,0,0,0-1.76,1.13,1.88,1.88,0,0,0-.14,1c0,.32.07.65.13,1,.06-.32.08-.65.13-1a1.84,1.84,0,0,1,.24-.86,1.61,1.61,0,0,1,1.41-.79,1.91,1.91,0,0,0,1.73-1.19A2.08,2.08,0,0,0,93.38,183.32Zm31.58-2c0-.32-.07-.65-.13-1-.06.32-.08.65-.13,1a2,2,0,0,1-.21.87,1.6,1.6,0,0,1-1.37.84,1.94,1.94,0,0,0-1.77,1.13,2,2,0,0,0-.13,1c0,.32.07.65.13,1,.06-.32.08-.65.13-1a1.84,1.84,0,0,1,.24-.86,1.61,1.61,0,0,1,1.41-.79,1.91,1.91,0,0,0,1.73-1.19A2.08,2.08,0,0,0,125,181.27ZM132.72,124c0-.33-.07-.65-.13-1-.06.33-.08.65-.12,1a2.15,2.15,0,0,1-.22.87,1.59,1.59,0,0,1-1.37.83,1.94,1.94,0,0,0-1.77,1.13,2,2,0,0,0-.13,1c0,.33.07.65.13,1,.06-.33.08-.65.13-1a1.8,1.8,0,0,1,.24-.85,1.59,1.59,0,0,1,1.41-.79,1.93,1.93,0,0,0,1.73-1.19A2.08,2.08,0,0,0,132.72,124ZM113.28,135.8a1.85,1.85,0,0,1-.76.46,1.58,1.58,0,0,1-1.56-.37,1.51,1.51,0,0,0-.43-.32q-.14.21-.3.42a1.54,1.54,0,0,1,.36.27,1.9,1.9,0,0,0,2.07.38,2,2,0,0,0,.8-.66c.2-.26.42-.51.6-.78C113.79,135.39,113.54,135.6,113.28,135.8Zm29.63,38.83a1.87,1.87,0,0,1-.86-.24,1.64,1.64,0,0,1-.79-1.41,1.9,1.9,0,0,0-1.19-1.73,2,2,0,0,0-1-.1c-.33,0-.66.07-1,.12.32.06.65.09,1,.13a2,2,0,0,1,.86.22,1.58,1.58,0,0,1,.84,1.37,1.92,1.92,0,0,0,1.13,1.76,1.9,1.9,0,0,0,1,.14c.33,0,.65-.07,1-.13C143.56,174.7,143.24,174.67,142.91,174.63ZM125.12,202.2a1.88,1.88,0,0,0-1.19-1.73,1.85,1.85,0,0,0-1-.1c-.33,0-.66.06-1,.12.32.06.65.09,1,.13a1.86,1.86,0,0,1,.86.22,1.58,1.58,0,0,1,.84,1.37,1.71,1.71,0,0,0,.11.63l.6.12A1.53,1.53,0,0,1,125.12,202.2Zm-17.89-25.68a1.87,1.87,0,0,1-.86-.24,1.61,1.61,0,0,1-.79-1.41,1.9,1.9,0,0,0-1.19-1.73,2.08,2.08,0,0,0-1-.1c-.32,0-.65.07-1,.13.32.05.65.08,1,.12a2,2,0,0,1,.87.22,1.59,1.59,0,0,1,.84,1.37,1.89,1.89,0,0,0,2.17,1.9c.32-.05.65-.07,1-.13C107.88,176.59,107.55,176.56,107.23,176.52Zm24-28.76a1.73,1.73,0,0,1-.85-.25,1.59,1.59,0,0,1-.79-1.4,1.92,1.92,0,0,0-1.19-1.73,2,2,0,0,0-1-.11c-.33,0-.65.07-1,.13.33.06.65.09,1,.13a1.87,1.87,0,0,1,.87.22,1.6,1.6,0,0,1,.84,1.37,1.92,1.92,0,0,0,1.12,1.76,1.89,1.89,0,0,0,1,.13c.33,0,.66-.07,1-.13C131.91,147.83,131.58,147.8,131.25,147.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,129c-3.32.73-10.14-3.29-12.41-8.05-.15-.33.52-3.64,1.14-7.71.37-2.46.73-5.22.87-7.76,0-.52,15.71,4.76,15.71,4.76a40.53,40.53,0,0,0-2.08,9.66,5.14,5.14,0,0,0,.05,1s0,.1,0,.17C145.25,123.14,145.3,128.25,141.75,129Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,121s0,.11,0,.17a10,10,0,0,1-1.64,0c-9.36-.72-11.18-12.59-11.49-15.59,2.81.56,15.15,4.72,15.15,4.72a40.31,40.31,0,0,0-2.09,9.66A7.07,7.07,0,0,0,145,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5,85.57c-1.87,5.61.73,22,4.66,25.75,5.71,5.42,15.24,6.15,19.89-.75,4.51-6.68.75-28-3.66-31.42C143.89,74.12,132.24,77.28,129.5,85.57Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,95.73s-.08.06-.07.11c.21,1.1.26,2.39-.69,2.91,0,0,0,.07,0,.06C145.65,98.45,145.56,96.74,145.19,95.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,94.72c-1.8.14-1.39,3.73.27,3.6S145.54,94.61,144,94.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.65,95.18s.09,0,.09.09c.1,1.11.39,2.37,1.43,2.63,0,0,0,.06,0,.06C151.93,97.93,151.56,96.25,151.65,95.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,93.91c1.77-.34,2.32,3.23.68,3.54S151,94.19,152.51,93.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,93.24a13.53,13.53,0,0,0,1.33-.64,2.5,2.5,0,0,0,1.24-.92.79.79,0,0,0-.23-.91,1.91,1.91,0,0,0-1.92,0,2.85,2.85,0,0,0-1.46,1.38A.82.82,0,0,0,142.43,93.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,91.94a12.1,12.1,0,0,1-1.47-.21,2.33,2.33,0,0,1-1.45-.49.77.77,0,0,1-.06-.94,1.89,1.89,0,0,1,1.83-.56,2.77,2.77,0,0,1,1.81.86A.82.82,0,0,1,153.69,91.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.34,106.16c.29.23.6.56,1,.55a3.06,3.06,0,0,0,1.16-.42,0,0,0,0,1,.05,0,1.51,1.51,0,0,1-1.34.77,1.22,1.22,0,0,1-1-.89C145.21,106.16,145.29,106.13,145.34,106.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13,102.7a3.81,3.81,0,0,0,2.71,1.4,4.85,4.85,0,0,0,1.37-.1,1.1,1.1,0,0,0,.26-.06,1.2,1.2,0,0,0,.24-.06.26.26,0,0,0,.19-.27h0a.5.5,0,0,0,0-.12h0l0-.1c-.07-.86-.3-2.15-.3-2.15.33.12,2,.66,1.93.21a56.84,56.84,0,0,0-2.77-11.28.1.1,0,0,0-.2,0c.48,3.55,1.58,7,2.11,10.57a6.49,6.49,0,0,0-1.85-.34c-.11,0,.49,2.49.5,2.88a.16.16,0,0,1,0,0,5.28,5.28,0,0,1-4.05-.77C146.13,102.53,146.05,102.62,146.13,102.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,103.8a4.92,4.92,0,0,1-1.81,1.7,2.18,2.18,0,0,1-1.32.2c-1-.16-1.1-1-1-1.81a5,5,0,0,1,.32-1.2A6.37,6.37,0,0,0,150,103.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.16,105.5a2.18,2.18,0,0,1-1.32.2c-1-.16-1.1-1-1-1.81A2.27,2.27,0,0,1,148.16,105.5Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,94.73c1.06-3.2-.82-8.53.77-10,3.42-3.13,10.54,2.76,15.39,2.75s6.24-3,5.36-6.86-4.14-6.34-9.42-7.08a19.86,19.86,0,0,0-13.11,3.22s1.17-1.91.72-2.5-2.74,1.26-3.44,2a7.27,7.27,0,0,0-1.13,2.28,7.56,7.56,0,0,0-2.14-.21A4.46,4.46,0,0,0,125,79.67c-.08.28,1.63.49,2.83.54,0,0-2.21,3-2.14,5.53s4.12,14.58,5.07,14.7C132,100.6,134.33,96,134.76,94.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.27,79.9s.1,0,.06.06a8.11,8.11,0,0,0-2.51,3.62,9.91,9.91,0,0,0,0,5.24c.77,3.33,2.43,6.35,3.87,9.41,0,.09-.11.17-.15.08a35.53,35.53,0,0,1-4.19-10.14C124.77,85.13,125.45,81.62,128.27,79.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.33,83.52a11.39,11.39,0,0,1,4.27.24,16.58,16.58,0,0,1,3.67,1.78,16.23,16.23,0,0,0,8.7,2.31s0,.06,0,.06a14.21,14.21,0,0,1-8.1-1.66,35.22,35.22,0,0,0-3.81-2,14.76,14.76,0,0,0-4.73-.51A.13.13,0,0,1,135.33,83.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63,75.42a22.41,22.41,0,0,1,6-2,17.75,17.75,0,0,1,6.08-.26c3.48.54,6.71,2.73,7.55,6.3a7.58,7.58,0,0,1-.66,5.43.1.1,0,0,1-.18-.09,7.84,7.84,0,0,0-1.86-9.22c-2.88-2.45-6.89-2.61-10.45-2a32,32,0,0,0-6.49,1.92A0,0,0,0,1,136.63,75.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,99.16s-3.67-5.29-6.07-4,.34,9,3.15,10a2.86,2.86,0,0,0,3.84-1.52Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07,97.35s0,.06,0,.08c2,.8,3,2.64,3.72,4.54a1.59,1.59,0,0,0-2.37-.44s0,.11.06.1a1.76,1.76,0,0,1,1.93.62,8,8,0,0,1,.92,1.58c.1.17.42.08.35-.12l0,0C132.71,101.14,130.77,97.62,128.07,97.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.17 77.47 299.88 139.15 357.41 151.87 371.74 160.72 326.29 220.41 327.98 295.41 257.17 270.63 186.35 295.41 172.02 286.57 188.04 220.41 142.59 160.72 214.44 139.15 242.84 68.62 257.17 77.47",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.17 77.47 299.88 139.15 357.41 151.87 371.74 160.72 326.29 220.41 327.98 295.41 257.17 270.63 186.35 295.41 172.02 286.57 188.04 220.41 142.59 160.72 214.44 139.15 242.84 68.62 257.17 77.47",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.84 68.62 285.56 130.3 357.41 151.87 311.96 211.56 313.65 286.57 242.84 261.78 172.02 286.57 173.71 211.56 128.26 151.87 200.12 130.3 242.84 68.62",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.94 245.75 173.71 211.56 163.86 198.62 263.71 98.77 285.55 130.3 287.73 130.96 172.94 245.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.89 149.31 232.97 265.23 199.72 276.87 332.27 144.32 348.89 149.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.69 140.63 139.58 166.74 130.24 154.48 134.82 149.9 165.69 140.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.24 93.76 160.19 193.81 159.27 192.6 259.37 92.5 260.24 93.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.9 253.29 288.44 277.75 286.87 277.2 312.85 251.22 312.9 253.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,132.74c-2.48,16.52-8.65,50.67-1.74,60.94,9.07,13.48,39.39,22.65,47.34,25.38,3.46,1.19,12.71-21.36,10.81-24.77S142.37,178,140.24,176s-4.88-29.06-7.65-43C129.1,115.47,121.44,118.76,119.34,132.74Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,202.34c-1.24-1.4-.52-2.06,2.75-1.46s15.68,5.71,17.1,1.23-16.2-11.45-21.71-12-14.63.43-14.63.43C171.86,192.56,179,198.25,185.19,202.34Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.29,215.28c9.1,5.43,20.11,12.75,32.07,12.82a5.94,5.94,0,0,0,3.7-1.16c5.36.13,7-2.36,7-2.36,5-1.41,6.39-4.2,6.39-4.2s6.29.08,7-3.71c.78-4.26-8.22-3.54-13.4-6.17-11.89-6-27.1-17.9-30.35-20Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,213a86.87,86.87,0,0,0,10.7,4.68,86.4,86.4,0,0,0,12.53,2.64.1.1,0,0,1,0,.2,45.22,45.22,0,0,1-23.29-7.37C181.92,213,182,212.86,182.16,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.48,219.59c3.53,1.47,9.75,4,21.62,4.86,0,0,.05.07,0,.07a40.65,40.65,0,0,1-21.69-4.76C177.2,219.65,177.25,219.49,177.48,219.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,223.21c6.1,2.26,10.23,2.92,17,3.7a0,0,0,0,1,0,.08c-7.79-.09-10.61-1-17.1-3.58C174.7,223.32,174.8,223.12,175,223.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.16,152l-24.22,8.06s4.51-27.71,8.14-35.48c4.08-8.75,7.66-4.75,10.87,3.84S137.16,152,137.16,152Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,147.76a1.73,1.73,0,0,1-.85-.25,1.59,1.59,0,0,1-.79-1.4,1.92,1.92,0,0,0-1.19-1.73,2,2,0,0,0-1-.11c-.33,0-.65.07-1,.13.33.06.65.09,1,.13a1.87,1.87,0,0,1,.87.22,1.6,1.6,0,0,1,.84,1.37,1.92,1.92,0,0,0,1.12,1.76,1.89,1.89,0,0,0,1,.13c.33,0,.66-.07,1-.13C131.91,147.83,131.58,147.8,131.25,147.76Zm-.41-22.07a2,2,0,0,0-1.73,1.13,2,2,0,0,0-.13,1c0,.33.07.65.13,1,.06-.33.08-.65.13-1a1.8,1.8,0,0,1,.24-.85,1.59,1.59,0,0,1,1.41-.79.5.5,0,0,0,.17,0C131,126,130.91,125.86,130.84,125.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,147.93c-3.22.6-12.63,3.79-14.19,4.3-.83.27-4.06,1.49-4.88,1.75-.11,0,0,.19.07.16,1.57-.5,3.19-.84,4.77-1.33s11.27-3.38,14.27-4.76C135,148,134.92,147.91,134.85,147.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.88,135.42c0-.12-.15-.14-.18,0-.65,2.3-1.24,4.61-1.79,6.94a20.39,20.39,0,0,1,.35-3.73c0-.06-.07-.07-.09,0a16.85,16.85,0,0,0-.39,4.31c-.38,1.62-.75,3.24-1.1,4.87-.88,4.14-1.81,8.28-2.46,12.46a.3.3,0,0,0,.4.32c.83-.31,1.65-.64,2.46-1,.08,0,.06-.19,0-.17-.72.14-1.43.33-2.14.51,1-4,1.71-8,2.56-12S117.17,139.59,117.88,135.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,141.16c-.09-1.35-.19-2.69-.32-4,0,0,0,0,0,0,0,1,.08,2,.14,3-.43-1.93-.89-3.85-1.44-5.74,0,0,0,0,0,0,.41,3,1,5.91,1.45,8.87s1,5.79,1.49,8.68c-.52.27-1.05.52-1.58.77a.09.09,0,0,0,.06.16c.62-.17,1.24-.34,1.87-.49a.29.29,0,0,0,.25-.31C137.1,148.41,136.5,144.77,135.74,141.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "375.05 273.33 375.05 295.82 379.49 295.82 379.49 303.49 387.16 295.82 452.09 295.82 452.09 273.33 375.05 273.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.05,273.33c.07,7.58.27,15.08.3,22.49l-.3-.3,4.44,0h.32v.33l0,7.67-.63-.27,7.62-7.7.13-.12h.18l64.93-.07-.49.49,0-22.49.45.45c-22.19,0-54.5-.27-77-.45Zm0,0c22.76-.12,54.58-.47,77-.45h.45v.45l0,22.49v.49h-.49l-64.93-.06.3-.13-7.71,7.63-.64.63v-.89l0-7.67.33.33-4.44,0h-.3v-.3c0-7.58.23-15.08.29-22.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.54 279.3 388.29 281.91 391.32 282.77 389.38 285.24 389.49 288.39 386.54 287.3 383.58 288.39 383.7 285.24 381.76 282.77 384.79 281.91 386.54 279.3",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.06 279.3 401.81 281.91 404.83 282.77 402.89 285.24 403.01 288.39 400.06 287.3 397.1 288.39 397.22 285.24 395.27 282.77 398.3 281.91 400.06 279.3",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.57 279.3 415.32 281.91 418.35 282.77 416.41 285.24 416.52 288.39 413.57 287.3 410.62 288.39 410.74 285.24 408.79 282.77 411.82 281.91 413.57 279.3",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.09 279.3 428.84 281.91 431.87 282.77 429.92 285.24 430.04 288.39 427.09 287.3 424.13 288.39 424.25 285.24 422.31 282.77 425.33 281.91 427.09 279.3",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.6 287.3 440.6 279.3 438.85 281.91 435.82 282.77 437.77 285.24 437.65 288.39 440.6 287.3",
    style: {
      fill: "#E8B923"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.6,279.3l1.84,2.55c.7.1,2.06.54,3,.76l.23.06-.15.2-1.9,2.51,0-.14.14,3.14v.34l-.32-.12-3-1.06h.17l-3,1.06-.33.12,0-.34.13-3.14.05.14-1.91-2.51-.15-.2.24-.06c.92-.22,2.29-.67,3-.76l1.83-2.55Zm0,0L438.93,282c-1,.39-2.05.64-3.06,1l.08-.26,2,2.44a.13.13,0,0,1,0,.14l-.1,3.15-.31-.23,2.95-1.1c.09,0,.08,0,.17,0l2.95,1.1-.31.23-.1-3.15c0-.08,0-.08,0-.14l2-2.44.09.26c-1-.33-2.08-.58-3.06-1l-1.68-2.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.03 38.57 160.03 76.85 164.46 76.85 164.46 84.52 172.13 76.85 250.3 76.85 250.3 38.57 160.03 38.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,38.57c.13,11.29.22,27.19.28,38.28l-.28-.28h4.73v.29l0,7.67-.56-.23,7.64-7.69.11-.11,58.78-.13,19.54,0-.45.44.09-38.28.36.37c-22.5,0-67.77-.23-90.27-.37Zm0,0c22.49-.13,67.78-.34,90.27-.36h.36v.36l.09,38.28v.45h-.45c-21.8.11-56.12,0-78.17-.08l.26-.11-7.7,7.64-.55.55v-.78l0-7.67.29.3-4.43,0h-.28C159.7,65.88,160,50,160,38.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,57.76a10.9,10.9,0,1,1-10.9-10.9A10.9,10.9,0,0,1,191.06,57.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.3,
    cy: 56.19,
    r: 3.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.38,65.65v1.41a10.91,10.91,0,0,0,3.25,1.36,11.18,11.18,0,0,0,8.6-1.36V65.65a5.93,5.93,0,1,0-11.85,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.78,
    y: 51.14,
    width: 40.88,
    height: 0.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.78,
    y: 55.38,
    width: 40.88,
    height: 0.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.78,
    y: 59.62,
    width: 40.88,
    height: 0.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.78,
    y: 63.86,
    width: 20.26,
    height: 0.62,
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.ed93c994ab25d3bd56e600597ce725f4.svg";
export { ForwardRef as ReactComponent };